<template>
	<errorContainer :error="erreur" :warning="warning">
		<transition name="slide">
			<div
				class="container-layout details-document-package"
				:class="{
					'container-layout': $screen.width > 576,
					'container-mobile': $screen.width <= 576
				}"
			>
				<!-- <pre>{{ roleByStepToSend }}</pre> -->
				<div class="form">
					<b-row v-if="!useExternalDocumentId">
						<b-col md="12" class="px-0">
							<h1 :class="[`${!$screen.sm ? 'main-page-title' : ''}`, { 'is-pwa': $isPwa() }]">{{ FormMSG(55, 'Document Details') }}</h1>
						</b-col>
					</b-row>
					<b-row class="mt-0">
						<b-col class="p-0">
							<b-card no-body :style="useExternalDocumentId ? 'border: none; padding: 0; margin-bottom: 0;' : ''">
								<b-row v-if="!useExternalDocumentId" class="back-with-title cursor-pointer pt-0 pb-2 pl-0" :class="{ 'mt-16': $isPwa() }">
									<b-col cols="6">
										<button class="btn-transparent" @click="handleClickGoBack">
											<component :is="getIconLucide('ArrowLeft')" color="rgba(6, 38, 62, 0.65)" :size="22" class="icon" />
											<span class="title-back-bolder mx-0">
												{{ FormMSG(163, 'Back') }}
											</span>
										</button>
									</b-col>
								</b-row>
								<b-card-text class="pt-4">
									<div class="px-1">
										<b-row v-if="docs.length > 0">
											<b-col cols="12" xl="12">
												<div v-if="newDoc">
													<div class="card card-border-blue-light p-3">
														<b-row>
															<b-col cols="6">
																<b-form-group :label="FormMSG(10, 'Object')" label-for="docName" label-cols="3">
																	<b-form-input
																		id="docName"
																		v-model="newDoc.name"
																		type="text"
																		:disabled="isDocumentPackage || isGlobalDisabled"
																	/>
																</b-form-group>
																<b-form-group :label="FormMSG(11, 'Type')" label-for="docType" label-cols="3">
																	<b-form-select
																		v-if="!isDocumentPackage"
																		id="docType"
																		v-model="newDoc.type"
																		:options="optionsForDocType"
																		size="md"
																		:disabled="isDocumentPackage || isGlobalDisabled"
																		@change="handleChangeType"
																	/>
																	<b-form-input v-else :value="FormMSG(421, 'Onboarding package')" disabled />
																</b-form-group>
																<b-row v-if="!isDocumentPackage">
																	<b-col>
																		<b-form-group
																			v-if="newDoc.type === 9"
																			:label="FormMSG(13, 'File')"
																			label-for="docFileBrowse"
																			label-cols="3"
																		>
																			<b-form-file
																				id="docFileBrowse"
																				ref="pdfFileId"
																				v-model="pdfFile"
																				:browse-text="FormMSG(113, 'Browse')"
																				name="test"
																				accept=".docx,.pdf"
																				:placeholder="FormMSG(156, 'Choose a file or drop it here...')"
																				:drop-placeholder="FormMSG(157, 'Drop file here...')"
																				:disabled="isDocumentPackage || isGlobalDisabled"
																				@change="submitDocFile"
																			/>
																		</b-form-group>
																		<b-form-group
																			v-if="newDoc.type != 9"
																			:label="FormMSG(13, 'File')"
																			label-for="docFileBrowse"
																			label-cols="3"
																		>
																			<b-form-file
																				id="docFileBrowse"
																				ref="pdfFileId"
																				v-model="pdfFile"
																				:browse-text="FormMSG(113, 'Browse')"
																				name="test"
																				accept=".jpg,.png,.gif,.pdf,.xlsx,.xls,.doc,.docx,.txt"
																				:placeholder="FormMSG(156, 'Choose a file or drop it here...')"
																				:drop-placeholder="FormMSG(157, 'Drop file here...')"
																				:disabled="isDocumentPackage || isGlobalDisabled"
																				@change="submitDocFile"
																			/>
																		</b-form-group>
																	</b-col>
																</b-row>
																<b-row v-show="!isDocumentPackage">
																	<b-col cols="7" offset="3" class="d-flex justify-content-start align-items-end">
																		<b-form-group label="" class="w-100">
																			<b-form-input
																				:value="newDoc.fileName"
																				:placeholder="FormMSG(58, 'File name...')"
																				disabled
																				style="margin-left: -4px"
																			/>
																		</b-form-group>
																	</b-col>
																	<b-col
																		v-if="newDoc.fileName && newDoc.fileName.length > 0"
																		cols="2"
																		class="d-flex justify-content-start align-items-center"
																		style="margin-top: -12px"
																	>
																		<button
																			:class="{
																				'btn-transparent text-color-burning-tomato': $screen.width > 576,
																				'btn btn-danger mr-2': $screen.width <= 576
																			}"
																			:disabled="isDocumentPackage || isGlobalDisabled"
																			@click="removePdfFile"
																		>
																			<component :is="getIconLucide('Trash2')" :size="22" :stroke-width="1.5" />
																		</button>
																		<button
																			:class="{
																				'btn-transparent text-color-rhapsody-in-blue': $screen.width > 576,
																				'btn btn-primary': $screen.width <= 576
																			}"
																			@click="handlePreviewDoc"
																		>
																			<component :is="getIconLucide('Eye')" :size="22" :stroke-width="1.5" />
																		</button>
																	</b-col>
																</b-row>
															</b-col>
															<b-col cols="6">
																<b-row>
																	<b-col cols="6">
																		<b-form-checkbox
																			id="toApp"
																			v-model="newDoc.availableOnline"
																			size="lg"
																			:disabled="isDocumentPackage || isGlobalDisabled"
																			class="pj-cb pb-1"
																		>
																			{{ FormMSG(14, 'View in App') }}
																		</b-form-checkbox>
																	</b-col>
																	<b-col cols="6">
																		<b-form-checkbox
																			id="toEmail"
																			v-model="newDoc.toEmail"
																			size="lg"
																			:disabled="isDocumentPackage || isGlobalDisabled"
																			class="pj-cb pb-1"
																		>
																			{{ FormMSG(15, 'Send by email') }}
																		</b-form-checkbox>
																	</b-col>
																</b-row>
																<b-row>
																	<b-col cols="6">
																		<b-form-checkbox
																			id="toSms"
																			v-model="newDoc.toSms"
																			size="lg"
																			:disabled="isDocumentPackage || isGlobalDisabled"
																			class="pj-cb pb-1"
																		>
																			{{ FormMSG(41, 'Send SMS') }}
																		</b-form-checkbox>
																	</b-col>
																	<b-col cols="6">
																		<b-form-checkbox
																			id="toWhatsApp"
																			v-model="newDoc.toWhatsApp"
																			size="lg"
																			:disabled="isDocumentPackage || isGlobalDisabled"
																			class="pj-cb pb-1"
																		>
																			{{ FormMSG(42, 'Send WhatsApp') }}
																		</b-form-checkbox>
																	</b-col>
																</b-row>
																<b-form-group :label-cols="0" class="mt-2">
																	<b-form-textarea
																		id="body"
																		v-model="newDoc.body"
																		:placeholder="FormMSG(16, 'Enter message here...')"
																		:no-resize="true"
																		rows="5"
																		:disabled="isDocumentPackage || isGlobalDisabled"
																	/>
																	<!-- :state="newDoc.body && newDoc.body.length < 4000" -->
																</b-form-group>
															</b-col>
														</b-row>
														<div>
															<div class="divider" />
															<div class="sub-title mb-2">{{ FormMSG(168, 'Options') }}</div>
															<b-row>
																<b-col>
																	<b-form-checkbox
																		id="requireSignManager"
																		v-model="newDoc.requireManagerApproval"
																		size="lg"
																		:disabled="isDocumentPackage || isGlobalDisabled"
																		@change="handleChangeManagerApproval"
																	>
																		<div class="mt-1">{{ FormMSG(170, 'Need signature/approval') }}</div>
																		<!-- :disabled="
																			isDocumentPackage || disableRequireApproval || isGlobalDisabled
																		" -->
																		<!-- Need signature/approval -->
																	</b-form-checkbox>
																</b-col>
															</b-row>
															<b-collapse :visible="newDoc.requireManagerApproval">
																<b-row v-if="newDoc.requireManagerApproval" class="mt-3">
																	<b-col>
																		<fieldset class="card-inside">
																			<legend class="card-inside">
																				{{ FormMSG(152, 'Approval steps') }}
																			</legend>
																			<div class="container-field">
																				<choice-step-document
																					:is-disabled="isDocumentPackage || isGlobalDisabled"
																					:current-document="newDoc"
																					@choice-step-document:change="handleChoiceStepDocumentChange"
																				/>
																			</div>
																		</fieldset>
																	</b-col>
																</b-row>
															</b-collapse>
														</div>
														<div v-if="isPdfFile()">
															<div class="divider" />
															<div class="sub-title mb-2">{{ FormMSG(167, 'Watermark options') }}</div>
															<b-row class="pb-2">
																<b-col sm="12" md="12" lg="12" xl="12">
																	<b-form-checkbox
																		id="watermark"
																		v-model="newDoc.useWatermark"
																		size="lg"
																		:disabled="isDocumentPackage || isGlobalDisabled"
																	>
																		<div class="mt-1">{{ FormMSG(21, 'Add Watermark') }}</div>
																	</b-form-checkbox>
																</b-col>
															</b-row>
															<b-collapse :visible="newDoc.useWatermark">
																<div class="container-field">
																	<b-row v-if="isPdfFile() && newDoc.useWatermark">
																		<b-col sm="12" md="6" lg="6" xl="6">
																			<b-form-group :label="FormMSG(22, 'Watermark text')" label-for="watermarkText">
																				<b-form-input
																					id="watermarkText"
																					v-model="newDoc.watermarkText"
																					type="text"
																					:disabled="isDocumentPackage || isGlobalDisabled"
																				/>
																			</b-form-group>
																		</b-col>
																		<b-col
																			v-if="newDoc.useWatermark"
																			sm="12"
																			md="6"
																			lg="6"
																			xl="6"
																			class="d-flex justify-content-start align-items-end"
																			style="margin-bottom: 12px"
																		>
																			<b-form-checkbox
																				id="withusername"
																				v-model="newDoc.watermarkWithUser"
																				size="lg"
																				:disabled="isDocumentPackage || isGlobalDisabled"
																				class="pj-cb pb-1"
																			>
																				{{ FormMSG(23, 'With user name') }}
																			</b-form-checkbox>
																		</b-col>
																	</b-row>
																	<b-row v-if="isPdfFile() && newDoc.useWatermark" class="pb-1">
																		<b-col sm="12" md="6" lg="6" xl="6">
																			<b-form-group :label="FormMSG(24, 'Watermark image')" label-for="watermarkImage">
																				<b-form-file
																					id="watermarkImage"
																					ref="wmFileFieldId"
																					v-model="wmImageFile"
																					:browse-text="FormMSG(113, 'Browse')"
																					accept=".jpg,.png,.gif"
																					:placeholder="FormMSG(212, 'Choose watermark image or drop it here...')"
																					:drop-placeholder="FormMSG(213, 'Drop file here...')"
																					:disabled="isDocumentPackage || isGlobalDisabled"
																					@change="submitWmFile"
																				/>
																			</b-form-group>
																		</b-col>
																		<b-col
																			:sm="`${
																				newDoc.watermarkPictureFileName && newDoc.watermarkPictureFileName.length > 0
																					? 10
																					: 12
																			}`"
																			:md="`${
																				newDoc.watermarkPictureFileName && newDoc.watermarkPictureFileName.length > 0
																					? 4
																					: 6
																			}`"
																			:lg="`${
																				newDoc.watermarkPictureFileName && newDoc.watermarkPictureFileName.length > 0
																					? 4
																					: 6
																			}`"
																			:xl="`${
																				newDoc.watermarkPictureFileName && newDoc.watermarkPictureFileName.length > 0
																					? 4
																					: 6
																			}`"
																			class="d-flex justify-content-start align-items-end"
																			style="margin-bottom: -3px"
																		>
																			<b-form-group label="" class="w-100">
																				<b-form-input
																					:value="newDoc.watermarkPictureFileName"
																					:placeholder="FormMSG(58, 'File name...')"
																					disabled
																				/>
																			</b-form-group>
																		</b-col>
																		<b-col
																			v-if="newDoc.watermarkPictureFileName && newDoc.watermarkPictureFileName.length > 0"
																			sm="2"
																			md="2"
																			lg="2"
																			xl="2"
																			class="d-flex justify-content-start align-items-center"
																			style="margin-bottom: -16px"
																		>
																			<button
																				:class="{
																					'btn-transparent text-color-burning-tomato': $screen.width > 576,
																					'btn btn-danger mr-2': $screen.width <= 576
																				}"
																				:disabled="isDocumentPackage || isGlobalDisabled"
																				@click="removeWmFile"
																			>
																				<component :is="getIconLucide('Trash2')" :size="22" :stroke-width="1.5" />
																			</button>
																			<button
																				:class="{
																					'btn-transparent text-color-rhapsody-in-blue': $screen.width > 576,
																					'btn btn-primary': $screen.width <= 576
																				}"
																				@click="handlePreviewWm"
																			>
																				<component :is="getIconLucide('Eye')" :size="22" :stroke-width="1.5" />
																			</button>
																		</b-col>
																	</b-row>
																</div>
															</b-collapse>
														</div>
														<b-collapse :visible="showPasswordOptions">
															<div class="divider" />
															<div class="sub-title mb-2">
																{{ FormMSG(198, 'Password options') }}
															</div>
															<div>
																<div class="container-field">
																	<b-row>
																		<b-col cols="6">
																			<b-form-group :label="FormMSG(25, 'Pdf User password')" label-for="UserPwd">
																				<b-input-group class="mb-4">
																					<b-form-input
																						id="UserPwd"
																						v-model="newDoc.userPassword"
																						autocomplete="nope"
																						:type="!showTextConfirmPassword ? 'password' : 'text'"
																						:placeholder="
																							FormMSG(214, 'If protected, enter document user password .')
																						"
																						:disabled="isDocumentPackage"
																					/>
																					<b-input-group-append>
																						<button
																							class="btn-show-password"
																							type="button"
																							@click="showTextConfirmPassword = !showTextConfirmPassword"
																						>
																							<component
																								:is="getIconLucide('Eye')"
																								v-if="!showTextConfirmPassword"
																								color="#9c9d9e"
																								:size="16"
																							/>
																							<component
																								:is="getIconLucide('EyeOff')"
																								v-if="showTextConfirmPassword"
																								color="#9c9d9e"
																								:size="16"
																							/>
																						</button>
																					</b-input-group-append>
																				</b-input-group>
																			</b-form-group>
																		</b-col>
																		<b-col cols="6">
																			<b-form-group :label="FormMSG(26, 'Pdf Owner password')" label-for="OwnerPwd">
																				<b-input-group class="mb-4">
																					<b-form-input
																						id="OwnerPwd"
																						v-model="newDoc.ownerPassword"
																						:type="!showTextPassword ? 'password' : 'text'"
																						:placeholder="FormMSG(216, 'Enter document owner password.')"
																						:disabled="isDocumentPackage"
																					/>
																					<b-input-group-append>
																						<button
																							class="btn-show-password"
																							type="button"
																							@click="showTextPassword = !showTextPassword"
																						>
																							<component
																								:is="getIconLucide('Eye')"
																								v-if="!showTextPassword"
																								color="#9c9d9e"
																								:size="16"
																							/>
																							<component
																								:is="getIconLucide('EyeOff')"
																								v-if="showTextPassword"
																								color="#9c9d9e"
																								:size="16"
																							/>
																						</button>
																					</b-input-group-append>
																				</b-input-group>
																			</b-form-group>
																		</b-col>
																	</b-row>
																</div>
															</div>
														</b-collapse>
														<div v-if="!useExternalDocumentId">
															<b-row v-if="!isDocumentPackage || !isGlobalDisabled" class="pt-3">
																<b-col sm="12" md="4" lg="4" xl="4" class="d-flex justify-content-center align-items-center">
																	<b-form-group>
																		<h6>{{ lastPublishedOn }}</h6>
																	</b-form-group>
																</b-col>
																<b-col sm="12" md="4" lg="4" xl="4">
																	<b-form-group v-if="newDoc.type === 9">
																		<b-button
																			variant="success"
																			size="md"
																			class="btn btn-primary w-350-px"
																			block
																			@click="downloadPDF()"
																		>
																			{{ FormMSG(20, 'Download mail merge fields...') }}
																		</b-button>
																	</b-form-group>
																</b-col>
																<b-col sm="12" md="4" lg="4" xl="4">
																	<b-form-group>
																		<b-button
																			variant="primary"
																			size="md"
																			:disabled="disableSave"
																			class="btn btn-primary btn-md w-250-px float-right"
																			block
																			@click="curDocUpd()"
																		>
																			{{ FormMSG(18, 'Save modifications') }}
																		</b-button>
																	</b-form-group>
																</b-col>
															</b-row>
														</div>
														<div v-else>
															<b-row class="mt-3">
																<b-col sm="12" md="3" offset-md="6" lg="3" offset-lg="6" xl="3" offset-xl="6">
																	<b-button
																		variant="outline-primary"
																		class="w-250-px"
																		:disabled="disableSave"
																		block
																		@click="curDocUpd()"
																	>
																		{{ FormMSG(18, 'Save modifications') }}
																	</b-button>
																</b-col>
																<b-col sm="12" md="3" lg="3" xl="3">
																	<b-button
																		:disabled="loadingSendDocument"
																		variant="primary"
																		block
																		@click="handleSendDocument"
																	>
																		<b-spinner v-if="loadingSendDocument" small />
																		{{ FormMSG(1687, 'Send document') }}
																	</b-button>
																</b-col>
															</b-row>
														</div>
													</div>
													<b-modal
														v-model="successModal"
														:title="FormMSG(27, 'Success!')"
														class="modal-success"
														ok-variant="success"
														ok-only
														@ok="successModal = false"
													>
														{{ FormMSG(28, 'The new document has been saved.') }}
													</b-modal>
													<b-modal
														v-model="successModalDelete"
														:title="FormMSG(27, 'Success!')"
														class="modal-success"
														ok-variant="success"
														ok-only
														@ok="successModalDelete = false"
													>
														{{ FormMSG(29, 'Your document has been deleted.') }}
													</b-modal>
													<b-card v-if="!useExternalDocumentId" no-body class="card-border-blue-light">
														<b-card-header>
															<h4>{{ caption2 }}</h4>
														</b-card-header>
														<b-card-body>
															<b-row v-if="newDoc.type !== 11" class="pb-3">
																<b-col v-if="!isDocumentPackage" sm="12" md="6" lg="6" xl="6">
																	<b-input-group v-if="$screen.width >= 992">
																		<b-form-input
																			v-model="filter"
																			type="text"
																			:placeholder="FormMSG(31, 'Type to Search')"
																		/>
																		<b-input-group-append class="cursor-pointer">
																			<b-input-group-text class="btn-search">
																				<component
																					:is="getIconLucide('Search')"
																					v-if="filter.length === 0"
																					color="#FFFFFF"
																					:size="16"
																					class="icon"
																					:stroke-width="2.5"
																				/>
																				<component
																					:is="getIconLucide('X')"
																					v-else
																					color="#FFFFFF"
																					:size="16"
																					class="icon"
																					:stroke-width="2.5"
																					@click="filter = ''"
																				/>
																			</b-input-group-text>
																		</b-input-group-append>
																	</b-input-group>
																</b-col>
																<b-col sm="12" md="6" lg="6" xl="6">
																	<div class="float-right">
																		<b-button
																			variant="success"
																			:disabled="newDoc.xid === 0"
																			size="md"
																			class="w-250-px"
																			@click="showDeliveries()"
																		>
																			{{ FormMSG(219, 'Select receivers...') }}
																		</b-button>
																	</div>
																</b-col>
															</b-row>
															<!-- TABLE OF Departments use striped to highlight each even row   @row-selected="rowSelected"  :disabled="data.item.department!=0 && data.item.type==0" -->
															<b-row>
																<b-col cols="12" xl="12">
																	<CardListBuilder
																		v-if="$screen.width < 992"
																		:items="Dlvs"
																		:fields="deliFields"
																		@row-clicked="rowClicked"
																	>
																		<template slot="actions" slot-scope="data">
																			<b-button
																				v-if="
																					data.item.selected &&
																					data.item.status > 0 &&
																					newDoc.fileName &&
																					newDoc.fileName.length > 0
																				"
																				variant="primary"
																				size="sm"
																				@click="viewDocument(data.item)"
																			>
																				<i class="icon-eye" />
																			</b-button>
																			<b-button
																				v-if="data.item.senderStatus === 2 && newDoc.toSign"
																				variant="primary"
																				size="sm"
																				@click="viewDocument(data.item)"
																			>
																				<i class="icon-eye" />
																			</b-button>
																		</template>
																	</CardListBuilder>
																	<b-table
																		v-if="$screen.width >= 992 && newDoc.type !== 11"
																		ref="myTable"
																		:hover="hover"
																		responsive="sm"
																		sticky-header="600px"
																		selectable
																		:selected-variant="selectedColor"
																		:select-mode="selectMode"
																		:items="Dlvs"
																		:fields="deliFields"
																		:current-page="currentPage"
																		:filter="filter"
																		:per-page="perPage"
																		bordered
																		small
																		:head-variant="hv"
																		@row-clicked="rowClicked"
																	>
																		<template #cell(status)="data">
																			<div class="wrap-status">
																				<div
																					v-if="data.item.comments && data.item.comments !== ''"
																					v-tooltip.top="data.item.comments"
																					:class="`status ${data.item.validatedClass}`"
																					style="font-size: 0.7rem"
																				>
																					{{ data.value }}
																				</div>
																				<div
																					v-else
																					:class="`status ${data.item.validatedClass}`"
																					style="font-size: 0.7rem"
																				>
																					{{ data.value }}
																				</div>
																			</div>
																		</template>
																		<template #cell(senderStatus)="data">
																			<div class="wrap-status">
																				<div
																					v-if="data.item.comments"
																					v-tooltip.top="data.item.comments"
																					:class="`status ${data.item.myValidatedClass}`"
																					style="font-size: 0.7rem"
																				>
																					{{ data.value }}
																				</div>
																				<div
																					v-else
																					:class="`status ${data.item.myValidatedClass}`"
																					style="font-size: 0.7rem"
																				>
																					{{ data.value }}
																				</div>
																			</div>
																		</template>
																		<template #cell(view)="data">
																			<component
																				:is="getIconLucide('Eye')"
																				v-if="data.item.status > 0"
																				color="#06263E"
																				:size="16"
																				@click="viewDocument(data.item)"
																			/>
																		</template>
																	</b-table>
																	<div v-if="$screen.width >= 992 && newDoc.type === 11">
																		<table-hierarchical-document-delivery
																			:document-package-id="newDoc.id"
																			:current-document="newDoc"
																			:show-select-receiver="true"
																			@table-hierarchical-document-delivery:sign="
																				handleTableHierarchicalDocumentDeliverySign
																			"
																		/>
																	</div>
																</b-col>
															</b-row>
															<b-modal
																v-model="successSignModal"
																:title="FormMSG(120, 'Success!')"
																class="modal-success"
																ok-variant="success"
																ok-only
																@ok="successSignModal = false"
															>
																{{ FormMSG(122, 'The document has been signed.') }}
															</b-modal>
															<loading :active.sync="isLoading" :is-full-page="true" color="#00A09C" />
														</b-card-body>
													</b-card>
												</div>
											</b-col>
										</b-row>
									</div>
								</b-card-text>
							</b-card>
						</b-col>
					</b-row>
				</div>
				<b-modal
					v-model="openPictureModal"
					header-class="header-class-modal-doc-package"
					:title="FormMSG(253, 'Picture')"
					class="modal-success"
					ok-variant="success"
					ok-only
					@ok="openPictureModal = false"
				>
					<div>
						<b-img :src="imgToShow" fluid-grow />
					</div>
				</b-modal>
			</div>
		</transition>
	</errorContainer>
</template>

<script>
// import gql from 'graphql-tag';
import { store } from '@/store';
import Loading from 'vue-loading-overlay';
import languageMessages from '@/mixins/languageMessages';
import globalMixin from '@/mixins/global.mixin';
import { isNil, noTilde } from '@/shared/utils';
import { addUpdDocValConfig, deleteDocument, getDocument, getDocumentList, updateDocument } from '@/modules/document-package/cruds/document.crud';
import { classDocumentStatus } from '@/shared/global-status';
import { getFileExtension, getFileSrc } from '@/shared/helpers';
import * as icons from 'lucide-vue';
import TableHierarchicalDocumentDelivery from '@/modules/document-package/components/TableHierarchicalDocumentDelivery';
import ChoiceStepDocument from '@/modules/document-package/components/ChoiceStepDocument';
import moment from 'moment';
import { getDocumentDeliveries } from '@/cruds/document.crud';
import _ from 'lodash';
import { DOCUMENT_DELIVERY_STATUS, DOCUMENT_VALIDATION_STEP } from '@/shared/constants';
import { mapGetters } from 'vuex';
import { publishDocument, selectUserForDelivery } from '@/cruds/document.crud';
import { contracts } from '@/cruds/contract.crud';
import { getImgCommentList } from '@/cruds/images.crud';

const axios = require('axios').create();

export default {
	name: 'DocumentDetails',
	components: {
		Loading,
		TableHierarchicalDocumentDelivery,
		ChoiceStepDocument
	},
	mixins: [languageMessages, globalMixin],
	props: {
		hover: {
			type: Boolean,
			default: true
		},
		striped: {
			type: Boolean,
			default: true
		},
		bordered: {
			type: Boolean,
			default: true
		},
		small: {
			type: Boolean,
			default: false
		},
		fixed: {
			type: Boolean,
			default: false
		},
		externalDocumentId: {
			type: Number,
			default: 0,
			required: false
		},
		externalProjectId: {
			type: Number,
			default: 0,
			required: false
		},
		useExternalDocumentId: {
			type: Boolean,
			default: false,
			required: false
		}
	},
	data() {
		return {
			hv: 'dark',
			erreur: {},
			formDataObj: {},
			docs: [],
			Dlvs: [],
			curDoc: {},
			newDoc: {},
			currentPage: 1,
			currentIdx: 0,
			perPage: 0,
			warning: '',
			filter: '',
			isLoading: false,
			pdfFile: null,
			wmImageFile: null,
			displayAllCategories: false,
			stopPropagation: '',
			nativeEvent: '',
			selectMode: 'single',
			selectedColor: 'primary',
			successModal: false,
			successModalDelete: false,
			firstTime: true,
			lastPublishedOn: '',
			successSignModal: false,
			checkPasswordModal: false,
			timeZoneStr: '',
			timeZoneHourDif: 0,
			passwordInput: '',
			userIdSelected: 0,
			name: '',
			nameState: null,
			passwordState: null,
			useDigElecSign: false,
			selectedItem: null,
			isDocumentPackage: false,
			openPictureModal: false,
			imgToShow: '',
			requireSignManager: false,
			roleByStepToSend: [],
			disableSelectRequireApproval: true,
			showTextPassword: false,
			showTextConfirmPassword: false,
			isCreated: false,
			loadingSendDocument: false,
			isGlobalDisabled: false,
			DOCUMENT_VALIDATION_STEP
		};
	},
	computed: {
		...mapGetters({
			currentJobRequest: 'job-request/currentJobRequest'
		}),
		disableRequireApproval() {
			return isNil(this.newDoc.fileName) || (!isNil(this.newDoc.fileName) && this.newDoc.fileName.length === 0);
		},
		disableToSignByStep() {
			return (
				this.roleByStepToSend.length > 0 ||
				this.newDoc.docValConfigStep1.length > 0 ||
				this.newDoc.docValConfigStep2.length > 0 ||
				this.newDoc.docValConfigStep3.length > 0 ||
				this.newDoc.docValConfigStep4.length > 0
			);
		},
		showPasswordOptions() {
			if (this.isPdfFile()) {
				if (this.newDoc.useWatermark || this.newDoc.toSign) {
					return true;
				}
			}
			return false;
		},
		optionsForDocType() {
			let result = this.FormMenu(1011);

			result = result.filter((res) => res.value !== 11);

			result.sort((a, b) => {
				if (noTilde(a.text.trim()).toLowerCase() < noTilde(b.text.trim()).toLowerCase()) {
					return -1;
				}
				if (noTilde(a.text.trim()).toLowerCase() > noTilde(b.text.trim()).toLowerCase()) {
					return 1;
				}

				return 0;
			});

			return result;
		},
		deliFields() {
			return [
				{
					key: 'fullName',
					label: this.FormMSG(50, 'Name'),
					sortable: true
				},
				{
					key: 'user.departmentName',
					label: this.FormMSG(51, 'Department'),
					sortable: true
				},
				{
					key: 'user.functionName',
					label: this.FormMSG(52, 'Function'),
					sortable: true
				},
				{
					key: 'contractStartDate',
					label: this.FormMSG(118, 'Contract start date'),
					formatter: (v) => moment(v).format('DD/MM/YYYY'),
					sortable: true
				},
				{
					key: 'contractEndDate',
					label: this.FormMSG(19, 'Contract end date'),
					formatter: (v) => {
						const value = v.split('T')[0];
						return moment(value).format('DD/MM/YYYY');
					},
					sortable: true
				},
				{
					key: 'status',
					label: this.FormMSG(43, 'User Status'),
					formatter: (value) => {
						return this.GetTextFromMenuNumberAndMenuValue(1012, value); // 0 not published, 1 not received, 2 received, 3 read, 4 signed
					},
					sortable: true,
					class: 'text-center'
				},
				{
					key: 'senderStatus',
					label: this.FormMSG(46, 'Production Status'),
					formatter: (value, key, item) => {
						return this.getLabelStep(item.status, parseInt(value), item.currentStep, this.curDoc.requireManagerApproval); // 0 not published, 1 not received, 2 received, 3 read, 4 signed
					},
					sortable: true,
					class: 'text-center'
				},
				{
					key: 'view',
					label: this.FormMSG(44, 'View'),
					sortable: false,
					formatter: (v) => v,
					class: 'text-center'
				}
				// {
				// 	key: 'certificate',
				// 	label: this.FormMSG(48, 'Certificate'),
				// 	sortable: false,
				// 	formatter: (v) => v,
				// 	class: 'text-center'
				// }
			];
		},
		caption1() {
			return this.FormMSG(101, 'Document details');
		},
		caption2() {
			return this.FormMSG(102, 'Document shared with...');
		},
		disableSave() {
			if (
				this.newDoc.name !== this.curDoc.name ||
				this.newDoc.type !== this.curDoc.type ||
				this.newDoc.availableOnline !== this.curDoc.availableOnline ||
				this.newDoc.toEmail !== this.curDoc.toEmail ||
				this.newDoc.toSms !== this.curDoc.toSms ||
				this.newDoc.toWhatsApp !== this.curDoc.toWhatsApp ||
				// this.newDoc.toSign !== this.curDoc.toSign ||
				this.newDoc.requireManagerApproval !== this.curDoc.requireManagerApproval ||
				this.newDoc.watermarkWithUser !== this.curDoc.watermarkWithUser ||
				this.newDoc.watermarkText !== this.curDoc.watermarkText ||
				this.newDoc.useWatermark !== this.curDoc.useWatermark ||
				this.newDoc.body !== this.curDoc.body ||
				this.newDoc.userPassword !== this.curDoc.userPassword ||
				this.newDoc.ownerPassword !== this.curDoc.ownerPassword
			) {
				if (
					this.newDoc.requireManagerApproval !== this.curDoc.requireManagerApproval &&
					this.newDoc.requireManagerApproval === true &&
					this.roleByStepToSend.length === 0
				) {
					return true;
				}

				if (this.roleByStepToSend.length > 0) {
					return this.checkToSignWithUserIdZero();
				}

				return false;
			} else {
				if (this.newDoc.requireManagerApproval !== this.curDoc.requireManagerApproval && this.roleByStepToSend.length === 0) {
					return true;
				}

				if (this.roleByStepToSend.length > 0) {
					return this.checkToSignWithUserIdZero();
				}
			}

			return true;
		}
	},
	watch: {
		externalDocumentId: {
			async handler(newVal) {
				if (newVal > 0) {
					await this.reloadData(true, newVal);
				}
			},
			immediate: true,
			deep: true
		}
	},
	async created() {
		// refresh users deliveries list.
		this.$bus.$on('document-users-deliveries-refresh', async () => {
			try {
				await this.reloadData();
			} catch (error) {
				console.log('reload deliveries users list failed with error: ' + error);
			}
		});

		if (!this.useExternalDocumentId) {
			await this.reloadData();
		}

		if (!this.useExternalDocumentId && this.Dlvs.length <= 0) {
			this.isCreated = JSON.parse(this.$route.query.isCreated);
		} else if (this.Dlvs.length <= 0) {
			this.isCreated = true;
		}
	},
	methods: {
		async handleSendDocument() {
			this.loadingSendDocument = true;
			const contractList = await contracts(this.currentJobRequest.userId, this.currentJobRequest.id);
			let deliveryDetail = [];

			for (let i = 0; i < contractList.length; i++) {
				deliveryDetail.push({
					contractId: +contractList[i].id,
					userId: this.currentJobRequest.userId,
					projectId: this.currentJobRequest.targetProjectId
				});
			}
			await selectUserForDelivery(this.externalDocumentId, deliveryDetail);
			await publishDocument(this.externalDocumentId);

			this.createToastForMobile(this.FormMSG(527, 'Success'), this.FormMSG(1547, 'The document has sended successfully!'));
			this.loadingSendDocument = false;
		},
		checkToSignWithUserIdZero() {
			const idx = this.roleByStepToSend.findIndex((item) => (item.toSign && item.userId === 0) || (item.toSign && !item.userId));
			const step = this.roleByStepToSend.filter((item) => item.field === 'owner');

			if ((idx !== -1 && this.newDoc.requireManagerApproval === true) || (step.length === 0 && this.newDoc.requireManagerApproval === true)) {
				return true;
			}

			return false; // No matching object found, return false
		},
		handleChangeType(payload) {
			if (payload === 10) {
				this.disableSelectRequireApproval = false;
			}
		},
		handleChangeToSign(payload) {
			if (!payload) {
				this.disableSelectRequireApproval = true;
				this.handleChangeManagerApproval(payload);
				//console.log('handleChangeToSign', payload);
			} else {
				this.disableSelectRequireApproval = false;
			}
		},
		handleChoiceStepDocumentChange(payload) {
			this.roleByStepToSend = payload;
			// console.log('roleByStepToSend', this.roleByStepToSend);
		},
		handleTableHierarchicalDocumentDeliverySign(payload) {
			this.signDocFile(payload);
		},
		async handleClickGoBack() {
			if (this.isCreated === true) {
				if (!this.useExternalDocumentId) {
					let documentId = +store.getCurrentDocumentId();
					await deleteDocument(documentId).catch((e) => console.log(e));
				}
			}
			if (!isNil(this.$route.query.viaTabDocPackage)) {
				this.$router.push({
					path: `/documents?viaTabDocPackage=1`
				});
			} else {
				this.$router.push({
					path: '/documents'
				});
			}
		},
		signDocFile(item) {
			this.userIdSelected = item.user.id;
			this.selectedItem = item;
			// this.checkPasswordModal=true;
		},
		async reloadDlvsData() {
			try {
				const DocumentId = parseInt(this.newDoc.id, 10);

				this.Dlvs = await getDocumentDeliveries(DocumentId);
				await this.fillDlvs();
			} catch (error) {
				console.log(error);
				this.erreur = error;
			}
		},
		async fillDlvs() {
			this.isGlobalDisabled = false;
			const statuesToCheck = [DOCUMENT_DELIVERY_STATUS.SIGNED, DOCUMENT_DELIVERY_STATUS.VALIDATED, DOCUMENT_DELIVERY_STATUS.REFUSED];
			for (let i = 0; i < this.Dlvs.length; i++) {
				if (
					(!this.Dlvs[i].user.name && !this.Dlvs[i].user.firstName) ||
					(this.Dlvs[i].user.name.length === 0 && this.Dlvs[i].user.firstName.length === 0)
				) {
					this.Dlvs[i].fullName = this.Dlvs[i].user.email;
				} else {
					this.Dlvs[i].fullName = this.Dlvs[i].user.name + ' ' + this.Dlvs[i].user.firstName;
				}

				this.Dlvs[i].validatedClass = classDocumentStatus(this.Dlvs[i].status);
				if (this.isGlobalDisabled === false) {
					if (statuesToCheck.includes(+this.Dlvs[i].status)) {
						this.isGlobalDisabled = true;
					}
				}
				this.Dlvs[i].myValidatedClass = classDocumentStatus(this.Dlvs[i].senderStatus);

				// fetch comments on refused documents.
				if (this.Dlvs[i].senderStatus === DOCUMENT_DELIVERY_STATUS.REFUSED) {
					let comments = await getImgCommentList(this.Dlvs[i].xid, this.Dlvs[i].id);
					let highestIdComment = comments.reduce((highestComment, currentComment) => {
						// Parse the IDs before comparison
						const highestCommentId = parseInt(highestComment.id, 10);
						const currentCommentId = parseInt(currentComment.id, 10);

						// Compare the parsed IDs
						return currentCommentId > highestCommentId ? currentComment : highestComment;
					}, comments[0]); // Initialize with the first comment

					this.Dlvs[i].comments =
						highestIdComment && highestIdComment.message && !_.isEmpty(highestIdComment.message) ? highestIdComment.message : '';
				} else this.Dlvs[i].comments = '';
			}
		},
		setPublishedDate() {
			if (this.alreadyPublished()) {
				let date =
					this.newDoc.publishedOn.split('T')[0].substring(8) +
					'/' +
					this.newDoc.publishedOn.split('T')[0].substring(5, 7) +
					'/' +
					this.newDoc.publishedOn.split('T')[0].substring(0, 4);
				date = date + ' ' + this.newDoc.publishedOn.substring(11, 13) + ':' + this.newDoc.publishedOn.substring(14, 16);
				return this.FormMSG(57, 'Published by') + ' ' + this.newDoc.publisher.name + ' ' + this.newDoc.publisher.firstName + '    - ' + date;
			} else {
				return 'Not published yet';
			}
		},
		alreadyPublished() {
			const y = new Date('2013-05-23');
			const x = new Date(this.newDoc.publishedOn.substring(0, 10));
			if (x.getTime() > y.getTime()) {
				return true;
			} else {
				return false;
			}
		},
		async viewDocument(item) {
			let id = this.$route.params.id;

			if (this.useExternalDocumentId) {
				id = this.externalDocumentId;
			}
			try {
				let fileList = [];
				const record = await getDocument(id, {});

				if (record.type === 11) {
					fileList = record.childDocList.filter((list) => list.userId === null || parseInt(list.userId, 10) === 0);
					fileList = fileList.map((doc) => {
						const src = getFileSrc(doc, { contractId: item.contractId, requestId: store.userID(), userId: item.userId });
						return {
							...doc,
							fileName: this.replaceToRightFileNameExt(doc.fileName, doc.docSignedXid),
							src: `${src}?onlyViewDocument=false&deliveryParentId=${doc.firstDeliveryParentId}`,
							thumb: process.env.VUE_APP_PATH_IMG_THUMB_URL + this.getRightXidDocument(doc.xid, doc.docSignedXid),
							ext: getFileExtension(this.getRightXidDocument(doc.xid, doc.docSignedXid)),
							isHovered: false
						};
					});
				} else {
					const src = getFileSrc(record, { imageOnly: false, contractId: item.contractId, requestId: store.userID(), userId: item.userId });
					fileList.push({
						fileName: this.replaceToRightFileNameExt(record.fileName, item.xidSigned),
						type: record.type,
						xid: this.getRightXidDocument(record.xid, item.xidSigned),
						status: record.status,
						src: `${src}?onlyViewDocument=false&deliveryParentId=${record.firstDeliveryParentId}`,
						thumb: process.env.VUE_APP_PATH_IMG_THUMB_URL + this.getRightXidDocument(record.xid, item.xidSigned),
						ext: getFileExtension(this.getRightXidDocument(record.xid, item.xidSigned)),
						isHovered: false
					});
				}

				this.$previewImages({
					images: fileList,
					focusIndex: 0,
					options: {
						presentationMode: 'doc',
						// showStatusFileTag: true,
						hideCommentButton: false,
						hideDisLikeButton: false,
						hideLikeDislike: false,
						hideCropButton: true,
						hideDeleteButton: true,
						showSignFileButton: true
					}
				});
			} catch (error) {
				console.log(error);
			}
		},
		viewDocumentCertificate(item) {
			// console.log('in viewdocument certifacte')
			if (this.newDoc.toSign) {
				// needs to generate new doc for specific user, watermark specific or contract template
				//console.log("viewdocument  item.useWatermark && item.watermarkWithUserbefore userId:",item);
				// var tmp = store.userID()

				const urlStr =
					process.env.VUE_APP_GQL +
					'/GetDocumentCertificate/' +
					item.user.id +
					'/' +
					this.newDoc.id +
					'/' +
					this.newDoc.name +
					item.user.name +
					item.user.firstName +
					'Cert.docx';

				// console.log('viewDocumentCertificate url:', urlStr)
				window.open(urlStr); // in new window
			}
			return;
		},
		isPdfFile() {
			// check if file is a pdf
			if (isNil(this.newDoc.fileName) || this.newDoc.fileName.length === 0) {
				return false;
			}
			const fileName = this.newDoc.fileName;
			const nameLen = fileName.length;
			const lastDotPos = fileName.lastIndexOf('.');
			let fileNameSub = false;
			if (lastDotPos === -1) {
				return false;
			} else {
				//Remove +1 if you want the "." left too
				fileNameSub = fileName.substr(lastDotPos + 1, nameLen).toLowerCase();
				if (fileNameSub === 'pdf') {
					return true;
				}
			}
			return false;
		},
		showDeliveries() {
			// copy item content into curTs structure.
			// store.state.curDocument = this.newDoc;
			store.setCurrentDocForDeliveries(this.newDoc);
			//console.log("item id:", item.id);
			const deliveryLink = `/documents/delivery/${this.newDoc.id.toString()} `;
			// console.log("starting:", deliveryLink);
			this.$router.push({
				path: deliveryLink
			});
		},
		fillUpdatedDocument() {
			let updatedDocument = {};
			updatedDocument.type = parseInt(this.newDoc.type, 10);
			updatedDocument.name = this.newDoc.name;
			updatedDocument.fileName = this.newDoc.fileName;
			updatedDocument.body = this.newDoc.body.substring(0, 4000);
			updatedDocument.userPassword = this.newDoc.userPassword;
			updatedDocument.ownerPassword = this.newDoc.ownerPassword;
			updatedDocument.xid = this.newDoc.xid;
			updatedDocument.useWatermark = this.newDoc.useWatermark;
			updatedDocument.watermarkText = this.newDoc.watermarkText;
			updatedDocument.watermarkPictureXid = this.newDoc.watermarkPictureXid;
			updatedDocument.watermarkPictureFileName = this.newDoc.watermarkPictureFileName;
			updatedDocument.watermarkWithUser = this.newDoc.watermarkWithUser;
			updatedDocument.toSign = this.newDoc.requireManagerApproval; // force value to true if requireManagerApproval is checked (so remove this.newDoc.toSign 'value')
			updatedDocument.toEmail = this.newDoc.toEmail;
			updatedDocument.toSms = this.newDoc.toSms;
			updatedDocument.toWhatsApp = this.newDoc.toWhatsApp;
			updatedDocument.availableOnline = this.newDoc.availableOnline;
			updatedDocument.requireManagerApproval = this.newDoc.requireManagerApproval;
			updatedDocument.projectId = this.externalProjectId === 0 ? null : this.externalProjectId;

			return updatedDocument;
		},
		async downloadCertificate(item) {
			let id = this.$route.params.id;

			if (this.useExternalDocumentId) {
				id = this.externalDocumentId;
			}

			const fileName = 'Certificate' + Date.now().toString() + '.docx';
			const urlStr =
				process.env.VUE_APP_GQL +
				'/GetDocumentCertificate/' +
				item.userId +
				'/' +
				parseInt(id).toString() +
				'/' +
				parseInt(item.contractId).toString() +
				'/' +
				fileName;
			const response = await axios.get(urlStr, {
				responseType: 'arraybuffer'
			});
			const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
			const link = document.createElement('a');
			link.href = window.URL.createObjectURL(blob);
			link.download = fileName;
			link.click();
		},
		async downloadPDF() {
			let id = this.$route.params.id;

			if (this.useExternalDocumentId) {
				id = this.externalDocumentId;
			}

			await getDocument(id, {}).then(async (result) => {
				const urlStr = process.env.VUE_APP_PATH_IMG_URL + result.xid;
				const response = await axios.get(urlStr, {
					responseType: 'arraybuffer'
				});
				const blob = new Blob([response.data], { type: 'application/pdf' });
				const link = document.createElement('a');
				link.href = window.URL.createObjectURL(blob);
				link.download = result.xid;
				link.click();
			});
		},
		async curDocUpd() {
			try {
				this.isCreated = false;
				const updatedDocument = this.fillUpdatedDocument();
				const docId = +this.newDoc.id;

				const result = await updateDocument(docId, updatedDocument);
				// console.log({ result });

				this.curDoc = this.newDoc = {};

				if (updatedDocument.requireManagerApproval === false) {
					const idx = this.roleByStepToSend.findIndex((roleStep) => roleStep.step === 1 && roleStep.userId === -1);
					if (idx === -1) {
						this.roleByStepToSend.push({
							docId,
							step: 1,
							validationLevel: -1,
							toSign: true,
							userId: -1
						});
					}
				}

				await addUpdDocValConfig(this.roleByStepToSend);

				if (this.externalDocumentId > 0) {
					await this.reloadData(true, this.externalDocumentId);
				} else {
					await this.reloadData();
				}

				this.createToastForMobile(this.FormMSG(128, 'Success'), this.FormMSG(135, 'Document updated successfully'));
			} catch (e) {
				console.log(e);

				let myerrorObject = {
					err: ''
				};
				myerrorObject.err = e.message;
				this.erreur = myerrorObject;
			}
		},
		initValuesForNoRecords() {
			this.newDoc.name = ' NEW DOCUMENT';
			this.newDoc.fileName = '';
			this.newDoc.type = parseInt('0', 10);
			this.newDoc.fileName = '';
			this.newDoc.userPassword = '';
			this.newDoc.ownerPassword = '';
			this.newDoc.xid = '';
			this.newDoc.useWatermark = false;
			this.newDoc.watermarkText = '';
			this.newDoc.watermarkPictureXid = '';
			this.newDoc.watermarkPictureFileName = '';
			this.newDoc.watermarkWithUser = false;
			this.newDoc.toSign = false;
			this.newDoc.toEmail = false;
			this.newDoc.toSms = false;
			this.newDoc.toWhatsApp = false;
			this.newDoc.availableOnline = true;
			this.newDoc.body = '';
		},
		async reloadData(computed = true, externalDocumentId = 0) {
			let documentId = +store.getCurrentDocumentId();

			if (documentId === 0) {
				if (externalDocumentId > 0) {
					documentId = externalDocumentId;
				} else {
					documentId = +this.$route.params.id;
				}
			}

			const result = await getDocumentList({ documentId }, this.useExternalDocumentId === true ? +this.currentJobRequest.targetProjectId : null);
			this.docs = _.cloneDeep(result);

			for (let i = 0; i < this.docs.length; i++) {
				this.docs[i].fullName = this.docs[i].publisher.name + ' ' + this.docs[i].publisher.firstName;
			}

			if (this.docs.length > 0) {
				if (computed) {
					this.curDoc = this.docs[0];
					this.newDoc = Object.assign({}, this.curDoc);
				}

				this.isDocumentPackage = this.newDoc.type === 11;
				await this.reloadDlvsData();
			} else {
				this.initValuesForNoRecords();
			}
		},
		async delItem(id) {
			try {
				const documentId = +id;

				await deleteDocument(documentId).catch((e) => console.log(e));

				await this.reloadData();
			} catch (e) {
				this.erreur = e;
				console.log(e);
			}
		},
		rowClicked(item, index) {
			this.currentIdx = (this.currentPage - 1) * this.perPage + index;
			this.lastPublishedOn = this.setPublishedDate();
		},
		async removeDocument(xid) {
			// console.log('removing document :', xid)
			let retStr = '';
			let formData = new FormData(); // instantiate it
			formData.append('fileName', xid);
			const config = {
				headers: {
					Authorization: `Bearer ${store.state.token}`,
					'content-type': 'multipart/form-data'
				}
			};
			let urlStr = process.env.VUE_APP_GQL + '/removedocument';
			await axios
				.post(urlStr, formData, config)
				.then((response) => {
					retStr = response.data;
					//console.log("document removed:", retStr);
					this.isLoading = false;
				})
				.catch((error) => {
					console.log(error);
				});
			return retStr;
		},
		removeWmFile() {
			this.$bvModal
				.msgBoxConfirm(this.FormMSG(61, 'Are you sure to remove this file ?'), {
					title: this.FormMSG(62, 'Confirm'),
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'danger',
					okTitle: this.FormMSG(63, 'YES'),
					cancelTitle: this.FormMSG(64, 'NO'),
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: false
				})
				.then(async (v) => {
					if (!v) return;

					if (this.newDoc.watermarkPictureFileName && this.newDoc.watermarkPictureFileName.length > 0) {
						// new watermark selected, remove the old file from the server
						this.removeDocument(this.newDoc.watermarkPictureXid);
					}
					this.newDoc.watermarkPictureFileName = '';
					this.newDoc.watermarkPictureXid = '';
					this.curDocUpd();
				})
				.catch((err) => console.log(err));
		},
		async submitWmFile(ev) {
			this.isLoading = true;
			let wmImgFile = '';
			if (ev.type === 'drop') {
				wmImgFile = ev.dataTransfer.files[0];
			} else if (ev.type === 'change') {
				wmImgFile = ev.target.files[0];
			}
			//console.log("submitWmFile submit file:", wmImgFile);

			if (this.newDoc.watermarkPictureFileName && this.newDoc.watermarkPictureFileName.length > 0) {
				// new watermark selected, remove the old file from the server
				this.removeDocument(this.newDoc.watermarkPictureXid);
			}

			this.newDoc.watermarkPictureFileName = wmImgFile.name;
			this.formDataObj = new FormData();
			this.formDataObj.append('uploadimage', wmImgFile);
			this.formDataObj.append('fileName', wmImgFile.name);
			this.formDataObj.append('fileType', wmImgFile.type);
			this.formDataObj.append('resize', '1024');
			const urlStr = process.env.VUE_APP_GQL + '/upload';
			//console.log("submit file before axios call:", urlStr);

			// console.log('wmImgFIle submitWmFile:', wmImgFile)
			// var fd = this.formDataObj
			await axios
				.post(urlStr, this.formDataObj, {
					headers: {
						//...axios.defaults.headers,
						//  'Content-Type': `multipart/form-data; boundary=${form._boundary}`,
						Authorization: `Bearer ${store.state.token}`,
						'Content-Type': 'multipart/form-data'
						//fd.getHeaders()
					}
				})
				.then((result) => {
					//window.location.reload();
					// console.log('boundary:', this.formDataObj.getAll('uploadimage'))
					this.newDoc.watermarkPictureXid = result.data;
					// console.log('submitWmFile success this.newDoc.watermarkPictureXid:', this.newDoc.watermarkPictureXid)
					// save document with update
					this.curDocUpd();
					this.$refs['wmFileFieldId'].reset();
				})
				.catch(function () {
					console.log('boundary:', this.formDataObj.getAll('uploadimage'));
					// console.log(' submitWmFile FAILURE!!')
				})
				.finally(() => (this.isLoading = false));
		},
		removePdfFile() {
			this.$bvModal
				.msgBoxConfirm(this.FormMSG(61, 'Are you sure to remove this file ?'), {
					title: this.FormMSG(62, 'Confirm'),
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'danger',
					okTitle: this.FormMSG(63, 'YES'),
					cancelTitle: this.FormMSG(64, 'NO'),
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: false
				})
				.then(async (v) => {
					if (!v) return;

					if (this.newDoc.xid && this.newDoc.xid.length > 0) {
						//console.log("in submitDocFile remove old doc:", this.newDoc.xid)
						// new document selected, remove the old file from the server
						this.removeDocument(this.newDoc.xid);
						if (this.newDoc.xidGenerated && this.newDoc.xidGenerated.length > 0) {
							// remove also the previous xidGenerated if any
							this.removeDocument(this.newDoc.xidGenerated);
						}
					}
					this.newDoc.fileName = '';
					this.newDoc.xid = '';
					this.newDoc.xidGenerated = '';
					this.curDocUpd();
				})
				.catch((err) => console.log(err));
		},
		async submitDocFile(ev) {
			this.isLoading = true;
			let docFil = '';
			if (ev.type === 'drop') {
				docFil = ev.dataTransfer.files[0];
			} else if (ev.type === 'change') {
				docFil = ev.target.files[0];
			}
			//console.log("submitDocFile submit file:", docFil);
			let formData = new FormData();
			formData.append('uploadimage', docFil);
			formData.append('fileName', docFil.name);
			if (this.newDoc.xid && this.newDoc.xid.length > 0) {
				//console.log("in submitDocFile remove old doc:", this.newDoc.xid)
				// new document selected, remove the old file from the server
				this.removeDocument(this.newDoc.xid);
				if (this.newDoc.xidGenerated && this.newDoc.xidGenerated.length > 0) {
					// remove also the previous xidGenerated if any
					this.removeDocument(this.newDoc.xidGenerated);
				}
			}

			this.newDoc.fileName = docFil.name;
			formData.append('fileType', docFil.type);
			//console.log("in submitdocfile, fileName:", this.newDoc.fileName);
			const urlStr = process.env.VUE_APP_GQL + '/upload';
			// console.log('in submitdocfile, urlStr:', urlStr)
			// console.log('in submitdocfile, formData:', formData)
			await axios
				.post(urlStr, formData, {
					headers: {
						Authorization: `Bearer ${store.state.token}`,
						'Content-Type': 'multipart/form-data'
					}
				})
				.then((result) => {
					//console.log("submitDocFile success result:", result);
					this.newDoc.xid = result.data;
					this.newDoc.xidGenerated = '';
					// save document with update
					this.curDocUpd();
					this.$refs['pdfFileId'].reset();
				})
				.catch(function () {
					console.log(' submitDocFile FAILURE!!');
				})
				.finally(() => (this.isLoading = false));
		},
		getIconLucide(name) {
			return icons[name];
		},
		handlePreviewDoc() {
			const list = [
				{
					...this.newDoc,
					src: `${process.env.VUE_APP_GQL}/images/${this.newDoc.xid}`,
					thumb: '',
					ext: this.newDoc.fileName.split('.')[1]
				}
			];

			const index = 0;

			this.$previewImages({
				images: list,
				focusIndex: index,
				options: {
					presentationMode: 'doc',
					hideCommentButton: true,
					hideDisLikeButton: true,
					hideLikeDislike: true,
					hideCropButton: true,
					hideDeleteButton: true
				}
			});
		},
		handlePreviewWm() {
			if (isNil(this.newDoc.watermarkPictureXid) || (!isNil(this.newDoc.watermarkPictureXid) && this.newDoc.watermarkPictureXid.length === 0)) return;
			this.imgToShow = `${process.env.VUE_APP_GQL}/images/${this.newDoc.watermarkPictureXid}`;
			this.openPictureModal = true;
		},
		getLabelStep(status, senderStatus, currentStep, requireManagerApproval) {
			if (senderStatus === 5) {
				return this.GetTextFromMenuNumberAndMenuValue(1012, senderStatus).toUpperCase();
			}
			if (currentStep === DOCUMENT_VALIDATION_STEP.step0) {
				return this.GetTextFromMenuNumberAndMenuValue(1012, senderStatus).toUpperCase();
			}

			if (currentStep === DOCUMENT_VALIDATION_STEP.step1) {
				if (!requireManagerApproval) {
					return this.GetTextFromMenuNumberAndMenuValue(1012, senderStatus).toUpperCase();
				}
				return (this.GetTextFromMenuNumberAndMenuValue(1012, senderStatus) + ' - ' + this.FormMSG(84, 'step 1')).toUpperCase();
			}
			if (currentStep === DOCUMENT_VALIDATION_STEP.step2) {
				return (this.GetTextFromMenuNumberAndMenuValue(1012, senderStatus) + ' - ' + this.FormMSG(85, 'step 2')).toUpperCase();
			}
			if (currentStep === DOCUMENT_VALIDATION_STEP.step3) {
				return (this.GetTextFromMenuNumberAndMenuValue(1012, senderStatus) + ' - ' + this.FormMSG(86, 'step 3')).toUpperCase();
			}
			if (currentStep === DOCUMENT_VALIDATION_STEP.step4) {
				return (this.GetTextFromMenuNumberAndMenuValue(1012, senderStatus) + ' - ' + this.FormMSG(8677557, 'step 4')).toUpperCase();
			}
		},
		handleChangeManagerApproval(payload) {
			if (payload === false) {
				this.newDoc.requireManagerApproval = payload;
				this.roleByStepToSend = [];
			}
		}
	}
};
</script>

<style scoped>
.card-body >>> table > tbody > tr > td {
	cursor: pointer;
}
</style>
